<template>
  <div class="message-container">
    <div class="message-card">
      <h2 class="primary--text">
        🎉 Congratulations! <br />
        Your Application Has Been Submitted
      </h2>
      <p>
        Thank you for submitting your application. We will review it and get
        back to you soon.
      </p>
      <!-- <p>Your application Number is <strong>#SASDODE24202010</strong>.</p> -->
      <p>
        You will be redirected to the homepage in
        <strong>{{ countdown }}</strong> seconds.
      </p>
      <p>
        If you are not redirected,
        <a href="/home" class="redirect-link primary--text">click here</a>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      countdown: 10,
    };
  },
  mounted() {
    this.applicantId = localStorage.getItem("applicantId");
    this.debId = localStorage.getItem("debId");
    if (this.debId || this.applicantId) {
      this.startCountdown();
    } else {
      this.$router.push("/");
    }
  },
  methods: {
    startCountdown() {
      const interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(interval);
          this.$router.push("/"); // Redirect to homepage
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
.message-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 450px);
  padding: 20px;
}

.message-card {
  background-color: #fff;
  padding: 2rem;
  text-align: center;
}

p {
  margin-bottom: 0.5rem;
  color: #555;
  font-weight: 400;
}

a.redirect-link {
  text-decoration: none;
}

a.redirect-link:hover {
  text-decoration: underline;
}
</style>
